export default "__VITE_ASSET__DIwlEMv5__"